<div class="grid" [ngClass]="{'warp-no-result':!isResult$()}">
    <que-manipulations-toolbar *ngIf="!isEmpty$()"></que-manipulations-toolbar>
    <div class="scroll" [ngClass]="{'expanded':!isFilterListOpen$()}" *ngIf="isResult$() ; else thereIsNotResult">
        <que-reminders-list-header class="position-sticky"></que-reminders-list-header>
        <div *ngFor="let r of reminders$() ,let i =index">
            <que-reminders-list-item [isLast]="i+1==reminders$()?.length" [reminder]="r"> </que-reminders-list-item>
        </div>
        <ng-container *ngFor="let _ of [].constructor(3)">
            <div class="item-in-loading" *ngIf="loadingExtra$()"></div>
        </ng-container>
    </div>
</div>
<ng-template #thereIsNotResult>
    <div class="grid no-result" *ngIf="!loading$() else loading">
        <que-no-result [isEmpty]="isEmpty$()"  [type]="'reminder'" ></que-no-result>
    </div>
</ng-template>
<ng-template #loading>
    <div class="no-result">
        <ng-container *ngFor="let _ of [].constructor(10)">
            <div class="item-in-loading load-enimation"></div>
        </ng-container>
    </div>
</ng-template>